<template>
  <div class="user-details">
    <div class="info-layout">
      <h3>
        Information
        <icon-button icon="el-icon-setting" v-if="$root.isSystem" @click="$emit('edit')" />
      </h3>
      <p>
        <span>
          {{ user.name }} <br/>
        </span>
        Name
      </p>

      <p>
        <span>
          {{ user.email }} <br/>
        </span>
        E-mail
      </p>

      <p>
        <span>
          {{ user.address }} <br/>
        </span>
        Address
      </p>

      <p>
        <span>
          {{ user.zip }} <br/>
        </span>
        Zip
      </p>

      <p>
        <span>
          {{ user.city }} <br/>
        </span>
        City
      </p>

      <p>
        <span>{{ user.phoneNumber }}</span>
        Phone
      </p>

      <p>
        <span>{{ user.country.name }}</span>
        Country
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDetails',
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .center {
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/user/UserDetails.vue